import React from 'react';
import styled, { css } from 'styled-components';

import { color as colors } from '@workboard/wobo-ui';
import { SvgIcon } from '@material-ui/core';
import AccountTreeOutlined from '@material-ui/icons/AccountTreeOutlined';
import HomeOutlined from '@material-ui/icons/HomeOutlined';

import { IconType } from '../../types/teams.types';
import DynamicIcon from '../../../../vectors/dynamic_team.svg';

interface IIcon {
  $background?: string;
  $color?: string;
}

const IconStyles = css`
  width: ${({ theme }) => theme.spacing(2.5)}px;
  height: ${({ theme }) => theme.spacing(2.5)}px;
  border-radius: ${({ theme }) => theme.spacing(0.5)}px;
`;

const DynamicSvg = styled(SvgIcon)<IIcon>`
  background-color: ${({ $background }) =>
    $background ? colors($background) : 'transparent'};
  font-size: ${({ theme }) => theme.spacing(2.5)}px;
  ${IconStyles}

  svg path {
    fill: ${({ $color }) => $color || 'currentColor'};
  }
`;

const StyledIcon = styled(SvgIcon)<IIcon>`
  ${({ $background }) =>
    $background &&
    css`
      background-color: ${colors($background)};
    `}
  ${({ $color }) =>
    $color &&
    css`
      color: ${colors($color)};
    `}
  ${IconStyles}
`;

const Icon = ({
  type,
  blueColor,
}: {
  type: IconType;
  blueColor?: boolean;
}): JSX.Element => {
  switch (type) {
    case 'dynamic':
      return (
        <DynamicSvg $background="--white-000" $color="rgb(104, 117, 135)">
          <DynamicIcon />
        </DynamicSvg>
      );
    case 'functional':
      return (
        <StyledIcon
          component={AccountTreeOutlined}
          $background="--white-000"
          $color={blueColor ? '--blue-500' : '--gray-800'}
        />
      );
    case 'home':
      return (
        <StyledIcon
          component={HomeOutlined}
          $background="--blue-000"
          $color="--blue-500"
        />
      );
    default:
      return null;
  }
};

Icon.defaultProps = {
  blueColor: false,
};

export default Icon;
